import { render, staticRenderFns } from "./Opz2ReportPreview.vue?vue&type=template&id=31c7b472&scoped=true"
import script from "./Opz2ReportPreview.vue?vue&type=script&lang=ts"
export * from "./Opz2ReportPreview.vue?vue&type=script&lang=ts"
import style0 from "./Opz2ReportPreview.vue?vue&type=style&index=0&id=31c7b472&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c7b472",
  null
  
)

export default component.exports